<template>
  <HPopup class="h-sell-popup"
          ref="popup"
          v-show="visible">
    <div class="h-sell-body" v-if="itemInfo">
      <div class="popup-header">购买物品</div>

      <div class="sell-form h-outer-border around-4 bw2 bz0 h-bg brown-2">
        <HArtifact :artifact="itemInfo"></HArtifact>
        <div class="sell-form-item sell-gold">
          <p class="ls-1">售卖单价</p>
          <div>
            <input type="text" maxlength="9" spellcheck="false" readonly :value="itemInfo.gold">
          </div>
        </div>

        <div class="sell-form-item sell-amount">
          <p class="ls-1">购买数量</p>
          <div>
            <HInputNumber :min="1" :max="itemInfo.amount" v-model="amount"></HInputNumber>
          </div>
        </div>

        <div class="sell-form-item sell-cost">
          <p class="ls-1">总计花费</p>
          <div>
            <input type="text" spellcheck="false" readonly placeholder="0" :value="buyCost">
          </div>
        </div>

      </div>
    </div>

    <footer class="flex">
      <button v-click-sound-button
              class="h-btn normal btn-border"
              :disabled="submitDisable"
              @click="handleSubmit">
        购买
      </button>
      <button v-click-sound-button
              class="h-btn normal btn-border"
              @click="handleClose">
        取消
      </button>
    </footer>
  </HPopup>
</template>

<script>
  import HPopup from '@/components/h-popup/index.vue'
  import HArtifact from '@/components/h-artifact/index'
  import HInputNumber from '@/components/h-input-number/index'

  import { mapGetters } from 'vuex'
  import API from '@js/api'

  export default {
    name: 'sell-popup',

    data () {
      return {
        amount: 1,
        submitLoading: false,
      }
    },

    props: {
      visible: {
        type: Boolean,
        default: true
      },
      zIndex: {
        type: Number,
        default: 1000
      },
      itemInfo: {
        type: Object,
        default () {
          return {}
        }
      }
    },

    computed: {
      ...mapGetters('hero', [
        'gold'
      ]),

      buyCost () {
        return this.itemInfo.gold * this.amount || 0
      },

      submitDisable () {
        return !this.amount
      },
    },

    methods: {
      handleClose () {
        this.$emit('close')
      },

      handleFixAmount (e) {
        let v = e.target.value
        if (!/^\d+$/.test(v)) {
          v = +(v).replace(/[^\d]/g, '') || 0
        }
        this.amount = Math.max(+v, 0)
        this.$forceUpdate()
      },

      async handleSubmit () {
        try {
          if (this.submitLoading) {
            return
          }
          this.submitLoading = true
          if (this.amount <= 0) {
            this.$message('未设置有效数量')
            return
          }

          if (this.amount > this.itemInfo.amount) {
            this.$message('数量超过最大值')
            return
          }

          if (this.buyCost > this.gold) {
            this.$message('金币不足')
            return
          }

          await API.market.buy({
            id: this.itemInfo.id,
            amount: this.amount,
            cost: this.buyCost,
          })
          this.$emit('close')
          this.$emit('refresh')
          this.$message('物品已购买')
        } catch (err) {
          this.$message(err)
        } finally {
          this.submitLoading = false
        }
      },

    },

    components: {
      HPopup,
      HArtifact,
      HInputNumber,
    }
  }
</script>

<style lang="stylus" scoped>
  .h-sell-body
    padding 10px
    width 500px

  footer
    margin-top 30px
    justify-content space-evenly

  .sell-header
    padding 10px 0
    line-height 16px
    font-size 12px
    letter-spacing 1px
    text-align center
    goldText1()

  .sell-form
    position relative
    display flex
    justify-content space-between
    margin 10px 0
    padding 3px

  .h-artifact
    flex-shrink 0

  .sell-form-item
    position relative
    display flex
    flex-direction column
    justify-content space-evenly
    width 120px
    flex-shrink 0
    padding 2px 5px
    font-size 12px
    text-align center
    goldText1()
    > p
      line-height 24px
    input
      height 24px
      border 1px solid rgba(255, 255, 255, 0.25)
      line-height 22px
      font-size 12px
      letter-spacing 1px
      border-radius 2px
      background-color rgba(0, 0, 0, 0.25)

</style>
